import { extendTheme } from "@chakra-ui/react";
import React from "react";

const customIcons = {
  logo: {
    path: (
      <path
        d="M19.557.113C11.34.32 9.117 8.757 9.03 12.95c1.643-2.67 4.62-3.08 6.931-3.08 2.825.085 10.27.205 17.458 0C40.61 9.663 44.802 3.28 46 .112c-5.391-.085-18.228-.205-26.443 0zM14.422 14.234C3.332 14.234-.468 24.76.045 31.948c3.594-6.418 7.617-7.53 9.243-7.445h6.675c5.956 0 11.039-6.846 12.836-10.27H14.422z"
        fill="currentColor"
      />
    ),
    viewBox: "0 0 46 32",
  },
  // ... Add other custom icons here
};

const theme = extendTheme({
  styles: {
    global: {
      "html, body": {
        bgGradient:
          "linear-gradient(180deg, #f3f7fc 0%, #edf3fb 45%, #f8fbff 100%)",
        color: "gray.800",
      },
      "#root": {
        minHeight: "100vh",
      },
    },
  },
  fonts: {
    body: `Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"`,
  },
  fontWeights: {
    normal: 400,
    medium: 600,
    bold: 800,
  },
  icons: {
    // Do not spread `chakraTheme.icons` here, it's unnecessary
    ...customIcons,
  },
  components: {
    ModalOverlay: {
      baseStyle: {
        zIndex: 1280,
      },
    },
    Card: {
      baseStyle: {
        container: {
          borderRadius: "16px",
          borderWidth: "1px",
          borderColor: "blackAlpha.100",
          boxShadow: "0 10px 28px rgba(15, 23, 42, 0.08)",
          bg: "white",
        },
      },
    },
    Tabs: {
      variants: {
        line: {
          tab: {
            fontWeight: 600,
            color: "gray.600",
            _selected: {
              color: "gray.900",
              borderColor: "PTOrange.800",
            },
          },
        },
      },
    },
  },
  breakpoints: {
    sm: "480px",
    smm: "624px",
    md: "768",
    mdd: "880px",
    lg: "992",
    lgg: "1350px",
    xl: "1280px",
    xxl: "1600px",
  },
  colors: {
    PTBlue: {
      50: "#f4f8ff",
      100: "#e7f0ff",
      200: "#c7dcff",
      300: "#a3c5ff",
      400: "#78a8ff",
      500: "#4d89f5",
      600: "#346ed3",
      700: "#2754ab",
      800: "#1d3d80",
      900: "#142a59",
    },
    PTOrange: {
      100: "#FF86001A",
      200: "#FF860033",
      300: "#FF86004D",
      400: "#FF860066",
      500: "#FF860080",
      600: "#FF860099",
      700: "#FF8600B3",
      800: "#FF8600CC",
      900: "#FF8600E6",
      1000: "#FF8600FF",
    },
    PTRed: {
      100: "#D9134C1A",
      200: "#D9134C33",
      300: "#D9134C4D",
      400: "#D9134C66",
      500: "#D9134C80",
      600: "#D9134C99",
      700: "#D9134CB3",
      800: "#D9134CCC",
      900: "#D9134CE6",
      1000: "#D9134CFF",
    },
  },
});

export default theme;
